import {
  AISH_NAME_LONG as AishNameLong,
  AISH_NAME_SHORT as AishNameShort,
  AISH_URL_MAIN as AishUrlMain,
  AISH_URL_APPLY as AishUrlApply,
  ADAP_NAME_LONG as AdapNameLong,
  ADAP_NAME_SHORT as AdapNameShort,
  ADAP_URL_MAIN as AdapUrlMain,
  CSSII_NAME_LONG as IsNameLong,
  CSSII_NAME_SHORT as IsNameShort,
  CSSII_URL_APPLY as IsUrlApply,
  CSSII_URL_MAIN as IsUrlMain,
  DIA_NAME_SHORT as DiaNameShort,
  DIA_NAME_LONG as DiaNameLong,
  DIA_URL_APPLY as DiaUrlApply,
  DIA_URL_MAIN as DiaUrlMain,
  CSSFB_NAME_LONG as FbNameLong,
  CSSFB_NAME_SHORT as FbNameShort,
  CSSFB_URL_APPLY as FbUrlApply,
  CSSFB_URL_MAIN as FbUrlMain,
  CSSFSCDI_NAME_LONG as FscdiNameLong,
  CSSFSCDI_NAME_SHORT as FscdiNameShort,
  CSSFSCDI_URL_MAIN as FscdiUrlMain,
  CSSFSCDI_URL_APPLY as FscdiUrlApply
} from '@govalta-emu/alss-common';

export const AISH_NAME_LONG = AishNameLong;
export const AISH_NAME_SHORT = AishNameShort;
export const AISH_NAME_COMBINED = `${AishNameLong} (${AishNameShort})`;
export const AISH_URL_MAIN = AishUrlMain;
export const AISH_URL_APPLY = AishUrlApply;

export const ADAP_NAME_LONG = AdapNameLong;
export const ADAP_NAME_SHORT = AdapNameShort;
export const ADAP_NAME_COMBINED = `${AdapNameLong} (${AdapNameShort})`;
export const ADAP_URL_MAIN = AdapUrlMain;

export const CSSII_NAME_LONG = IsNameLong;
export const CSSII_NAME_SHORT = IsNameShort;
export const CSSII_URL_MAIN = IsUrlMain;
export const CSSII_URL_APPLY = IsUrlApply;

export const DIA_NAME_LONG = DiaNameLong;
export const DIA_NAME_SHORT = DiaNameShort;
export const DIA_NAME_COMBINED = `${DiaNameLong} (${DiaNameShort})`;
export const DIA_URL_APPLY = DiaUrlApply;
export const DIA_URL_MAIN = DiaUrlMain;

export const CSSFB_NAME_LONG = FbNameLong;
export const CSSFB_NAME_SHORT = FbNameShort;
export const CSSFB_NAME_COMBINED = `${FbNameLong } (${FbNameShort})`;
export const CSSFB_URL_MAIN = FbUrlMain;
export const CSSFB_URL_APPLY = FbUrlApply;

export const CSSFSCDI_NAME_LONG = FscdiNameLong;
export const CSSFSCDI_NAME_SHORT = FscdiNameShort;
export const CSSFSCDI_NAME_COMBINED = `${FscdiNameLong } (${FscdiNameShort})`;
export const CSSFSCDI_URL_MAIN = FscdiUrlMain;
export const CSSFSCDI_URL_APPLY = FscdiUrlApply;